import React, { useState, useRef, useEffect } from "react";
import Home from "./Home";
import Navbar from "./Navbar";
import { Routes, Route } from 'react-router-dom';
import About from "./About";
import Skills from "./Skills";
import Work from "./Work";
import Contact from "./Contact";
import Error from "./Error";


const App = () => {
    

    return (
        <>
            <Routes>
                <Route exact path='/' element={<Home />} />
                <Route exact path='/about' element={<About />} />
                <Route exact path='/skills' element={<Skills />} />
                <Route exact path='/work' element={<Work />} />
                <Route exact path='/contact' element={<Contact />} />
                <Route path="*" element={<Error />} />
            </Routes>
        </>
    )
}

export default App;

